import { useState, useEffect } from 'react';
import axios from 'axios';
import ExcelDownload from '../../../../component/common/button/ExcelDownload.jsx';
import Pagination from '../../../../component/common/dataGrid/Pagination.jsx';
import useModalStore from '../../../../zustand/store/useModalStore.js';
import useExcelConfirmYn from '../../../common/excel/useExcelConfirmYn.js';
import { usePatientOnly } from '../../../../hooks/useBreakPoint.js';
import { useTableArrowNav } from '../../../../hooks/useTableArrowNav.js';

import '../../../../css/data-grid.css'
import { useDynamicStyle } from '../../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../../images/icons/icons_component.js';

const PtmiDataGrid = ({
    dataHead, dataColumn, apiCall, apiCntCall, searchParams, searchParamsAdditional, onPatientSelect, percent, setIsWholeLoading, desc, openConfModal, isDown, setIsListToggle
}) => {
    const [dataList, setDataList] = useState([]);
    const [excelList, setExcelList] = useState([{}]);
    const [isSearched, setIsSearched] = useState(false);

    const excelHead = ['의료기관명', '기관코드', '지역', '종별', '의무기록번호', '중증도분류선별번호', '성명', '나이/성별', '주소지', '보험유형', '내원일자', '내원시간', '발병일자(*)', '발병시간(*)', '질병여부(*)', '의도성여부(*)', '손상기전(*)', '교통사고손상당사자', '안전벨트', '아동용좌석', '전면에어백', '측면에어백', '헬멧', '무릎및관절보호대', '기타(구명조끼 등)', '전혀착용안함', '비해당', '미상', '주진료과(*)', '내원경로(*)', '전원보낸의료기관종류', '전원보낸의료기관코드', '전원보낼의료기관종류', '전원보낼의료기관코드', '내원수단(*)', '구급활동일지', '주증상(*)', '응급증상 해당여부', '기타증상', '진료결과(*)', '진료결과기타사유', '환자내원시반응(*)', '수축기혈압', '이완기혈압', '분당맥박수', '분당호흡수', '체온', '내원 시 산소포화도', '중증도분류과정(최초)', '중증도분류결과(최초)', '중증도분류일자(최초)', '중증도분류시간(최초)', '중증도 분류자의 직종', '최초 분류자의 면허 또는 자격번호', '중증도분류과정(변경)', '중증도분류결과(변경)', '퇴실시 최종진료구역', '주된진료를 받은 응급의료센터', '전문의 진료여부', '전문의 진료일자', '전문의 진료시간', '격리구역 병상번호', '입원경로', '진료의사 면허번호', '퇴실일자(*)', '퇴실시간(*)', '퇴실진단(*)', '퇴실진단(영문명)', '입원일자', '입원시간', '입원후결과(퇴원형태)', '퇴원일자', '퇴원시간', '퇴원진단', '퇴원진단(영문명)', '전송일자', '상태'];
    const dataCode = ['EMOGDESC', 'PTMIEMCD', 'EMOGLOCA', 'EMOGGRDC2', 'PTMIIDNO', 'PTMIKTID', 'PTMINAME', 'PTMIBRXX', 'PTMIZIPC', 'PTMIIUKD', 'PTMIINDT', 'PTMIINTM', 'PTMIAKDT', 'PTMIAKTM', 'PTMIDGKD', 'PTMIARCF', 'PTMIARCS', 'PTMITAIP', 'PTMITSBT', 'PTMITSCS', 'PTMITSFA', 'PTMITSSA', 'PTMITSHM', 'PTMITSPT', 'PTMIETCT', 'PTMITSNO', 'PTMITSUR', 'PTMITSUK', 'PTMIDEPT', 'PTMIINRT', 'PTMIINTP', 'PTMIINCD', 'PTMIDCTP', 'PTMIDCCD', 'PTMIINMN', 'PTMIREID', 'SYPTCHCO', 'PTMIEMSY', 'PTMIETSY', 'PTMIEMRT', 'PTMIETTX', 'PTMIRESP', 'PTMIHIBP', 'PTMILOBP', 'PTMIPULS', 'PTMIBRTH', 'PTMIBDHT', 'PTMIVOXS', 'PTMIKPR1', 'PTMIKTS1', 'PTMIKTDT', 'PTMIKTTM', 'PTMIKJOB', 'PTMIKIDN', 'PTMIKPR2', 'PTMIKTS2', 'PTMIAREA', 'PTMIMDCD', 'PTMISDCD', 'SDMDSDDT', 'SDMDSDTM', 'PTMIBENO', 'PTMIHSRT', 'PTMIDRLC', 'PTMIOTDT', 'PTMIOTTM', 'DGOTDESC', 'DGOTNAME', 'PTMIHSDT', 'PTMIHSTM', 'PTMIDCRT', 'PTMIDCDT', 'PTMIDCTM', 'DGDCDESC', 'DGDCNAME', 'PTMIWKDT', 'PTMISTAT'];

    const [pageInfo, setPageInfo] = useState({
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0, // 전체 데이터 수
    });

    const [patientInfo, setPatientInfo] = useState({
        searchEmog: '',
        searchIdno: '',
        searchIndt: '',
        searchIntm: ''
    })

    const [selectPtmi, setSelectPtmi] = useState();

    // 데이터를 불러오는 함수
    if (searchParamsAdditional != null) {
        searchParamsAdditional.pageNum = parseInt(pageInfo.currentPage);
        searchParamsAdditional.displayRowsize = parseInt(pageInfo.itemsPerPage);
    }

    const totalObj = Object.assign({}, searchParams, searchParamsAdditional);

    // toast modal open function
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const EMIHPTMIListData = async () => {
        try {
            const response = await axios.get(apiCall,
                { params: totalObj }
            );
            setIsWholeLoading(false);
            setDataList(response.data);

            if (apiCntCall === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: response.data.length
                }));
            } else {
                EMIHPTMIListCnt();
            }
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const EMIHPTMIListCnt = async () => {
        try {
            const response = await axios.get(apiCntCall, {
                params: totalObj
            });
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    // 엑셀 데이터는 다운로드 버튼 클릭 시점에 조회 후 사유 모달을 연다
    // (검색 시 선조회하면 무거운 엑셀 쿼리가 첫 환자 상세조회와 DB에서 경합해 첫 클릭이 느려짐)
    const openConfModalWithExcel = async () => {
        setIsWholeLoading(true);
        try {
            const response = await axios.get('/ptmiapi/jinryo/bdJrNaeyoekExcel.do',
                { params: totalObj }
            );
            setExcelList(response.data);
            openConfModal();
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
            showNotiModal('엑셀 데이터 조회 중 오류가 발생했습니다.');
        } finally {
            setIsWholeLoading(false);
        }
    }

    // 페이지가 변경될 때마다 데이터를 새로 불러옴 (검색 후에만)
    useEffect(() => {
        if (isSearched) {
            setIsWholeLoading(true);
            EMIHPTMIListData();
        }
    }, [pageInfo.currentPage]);

    useEffect(() => {
        // 환자를 실제로 선택했을 때만 상세 조회 실행 (초기 마운트의 빈 값 호출 방지)
        if (onPatientSelect && patientInfo.searchIdno) {
            setIsWholeLoading(true);
            onPatientSelect(patientInfo);
        }
    }, [patientInfo]);

    useEffect(() => {
        if (dataList.length === 0 && setIsListToggle) {
            setIsListToggle(true);
        }
    }, [dataList]);

    const onHandlePage = (page) => {
        if (page !== pageInfo.currentPage) {
            setPageInfo(prev => ({
                ...prev,
                currentPage: page
            }));
        }
    };

    const search = () => {
        if (searchParams.searchEmog === '') {
            showNotiModal("먼저 해당 응급의료기관을 선택해주세요!");
        } else {
            setIsWholeLoading(true);
            setIsSearched(true);
            setSelectPtmi();
            setPageInfo(prev => ({
                ...prev,
                currentPage: 1,
            }));
            EMIHPTMIListData();
        }
    };

    const paginationInfo = {
        ...pageInfo,
        onPageChange: onHandlePage,
    }

    const perPageOptions = Array.from({ length: 10 }, (_, i) => {
        const perPage = (i + 1) * 10;
        return (
            <option key={perPage} value={perPage}>
                -- {perPage}건 씩 조회 --
            </option>
        );
    });

    const onHandlePerPage = (e) => {
        setPageInfo(prev => ({
            ...prev,
            itemsPerPage: parseInt(e.target.value)
        }));
    }

    const onClickPtmi = (data, key) => {
        setPatientInfo({
            searchEmog: data.PTMIEMCD, // 첫 번째 컬럼 값
            searchIdno: data.PTMIIDNO, // 두 번째 컬럼 값
            searchIndt: data.PTMIINDT, // 세 번째 컬럼 값
            searchIntm: data.PTMIINTM  // 네 번째 컬럼 값
        });
        setSelectPtmi(key);
        if(setIsListToggle) setIsListToggle(false);
    }

    // Dynamic Style Hook
    const { fontColor, primaryBackColor, lightBackColor, borderColorGray, hoverLightFontColor, selectGridCell } = useDynamicStyle();
    const confirmYn = useExcelConfirmYn();

    const patientOnly = usePatientOnly();

    const tableRef = useTableArrowNav(dataList);

    return (
        <div className={`ptmi flex flex-col flex-grow min-h-15 ${patientOnly ? 'h-full w-half' : 'hp-70'}`}>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className={fontColor}>{pageInfo.totalItems}</strong>건</span>
                <div className='btn_container'>
                    <select
                        name="itemsPerPage"
                        className='page_select'
                        value={pageInfo.itemsPerPage}
                        onChange={onHandlePerPage}
                    >
                        {perPageOptions}
                    </select>
                    <button onClick={search} className={`search_btn ${primaryBackColor}`}><Icons.Search16w />검색</button>
                    <ExcelDownload
                        excelHead={excelHead}
                        excelData={excelList}
                        searched={isSearched}
                        dataCode={dataCode}
                        excelFileName={`환자상세내역_${desc}`}
                        confirmYn={confirmYn}
                        openConfModal={openConfModalWithExcel}
                        isDown={isDown}
                    />
                </div>
            </div>
            <div className='data_grid_container overflow-hidden'>
                <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                <div className='data_list_table'>
                    <table className={borderColorGray}>
                        <thead>
                            <tr>
                                {dataHead.map((content, index) => (
                                    <th width={percent[index]} key={index}>
                                        {content}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody ref={tableRef}>
                            {dataList.length === 0 ? (
                                <tr>
                                    <td colSpan={dataHead.length} className='empty_box'>
                                        <span className={`data_empty ${lightBackColor}`}>
                                            {isSearched ? <Icons.EmptyDalgu /> : <Icons.NullDalgu />}
                                            {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                        </span>
                                    </td>
                                </tr>
                            ) : (
                                dataList.map((item, rowIndex) => {
                                    const regex = /[^0-9]/g;
                                    const key = item.PTMIIDNO.replace(regex, "") + rowIndex;
                                    const select = selectPtmi === key;
                                    const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                    // 선택된 데이터가 있다면 포커스 바로 이동
                                    const hasSelectedRow = dataList.some((row, rIdx) => selectPtmi === row.PTMIIDNO.replace(regex, "") + rIdx);
                                    let targetTabIndex = -1;
                                    if (hasSelectedRow) {
                                        if (select) targetTabIndex = 0;
                                    } else {
                                        if (rowIndex === 0) targetTabIndex = 0;
                                    }
                                    return (
                                        <tr
                                            className={`focus_tr_style ${gridColor} ${hoverLightFontColor} cursor-pointer ${select && select ? selectGridCell : ''}`}
                                            key={key}
                                            onClick={() => onClickPtmi(dataList[rowIndex], key)}
                                        >
                                            {dataColumn.map((idx, colIndex) => {
                                                const isFocusTargetCell = colIndex === 0;
                                                return (
                                                    <td key={colIndex} width={percent[colIndex]}
                                                        role={isFocusTargetCell ? 'link' : undefined}
                                                        className={isFocusTargetCell ? 'arrow_target' : ''}
                                                        tabIndex={isFocusTargetCell ? targetTabIndex : undefined}
                                                        onKeyDown={(e) => {
                                                            if (isFocusTargetCell && (e.key === 'Enter' || e.key === ' ')) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                onClickPtmi(dataList[rowIndex], key);
                                                            }
                                                        }}>
                                                        {item[idx]}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </table>
                </div>
                <hr className='mr-1-1 co_border_gray' />
            </div>
            {
                dataList.length === 0 ? (
                    <></>
                ) : (
                    <Pagination
                        paginationInfo={paginationInfo}
                        pageSet={7}
                    />
                )
            }
        </div >
    );
};

export default PtmiDataGrid;